export default __webpack_public_path__ + "6d77a04eb2c69c5e845372bb0432c9df.svg";